<template>
  <div class="profile-settings text-center">
    <TopMenu
      :title="$t('PROFILE.NOTIFICATIONS.PAGE_LABEL')"
      back-to="/dashboard/profile"
      dark-background/>
    <div class="container-fluid content">
      <form
        class="form-profile-settings m-2"
        @submit.prevent="save">
        <div
          v-for="(element, elementIndex) in localNotificationPreferences"
          :key="elementIndex">
          <div
            v-show="display(element)"
            class="mt-3 mb-4 text-left">
            <div class="row-item-transparent-with-border mt-3 mb-4 text-left">
              <h3>{{ $t('PROFILE.NOTIFICATIONS.' + element.notifiableElementName) }}</h3>
            </div>
            <div
              v-for="(type, typeIndex) in element.notificationTypeSubscriptions"
              :key="typeIndex">
              <FormCheckbox
                v-if="type.notificationTypeName !== 'NOTIFICATION_TYPE.SMS'"
                v-model="type.isSubscribed"
                :prepend="$t('PROFILE.NOTIFICATIONS.' + type.notificationTypeName)"
                :disabled="type.notificationTypeId === 2 && element.notifiableElementIsMandatorySubscription"
                class="row-item-transparent mb-1 pl-2"
                @input="handleElementSubscription(element)"/>
            </div>
          </div>
        </div>
        <ActionButton
          type="submit"
          class="btn btn-lg btn-primary btn-block mt-3 mb-3">{{ $t("PROFILE.NOTIFICATIONS.SAVE_BUTTON") }}</ActionButton>
      </form>
    </div>
    <BottomMenu />
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import ActionButton from '@/components/Actions/ActionButton';
import FormCheckbox from '@/components/Forms/FormCheckbox';
import FormSelect from '@/components/Forms/FormSelect';

export default {
  name: 'ProfileNotifications',
  components: {
    ActionButton,
    TopMenu,
    BottomMenu,
    FormCheckbox,
    FormSelect,
  },
  data() {
    return {
      localNotificationPreferences: [],
    };
  },
  computed: {
    ...mapState('member', ['selectedNotificationPreferences']),
  },
  watch: {
    selectedNotificationPreferences: {
      handler(newVal) {
        if (newVal) {
          this.localNotificationPreferences = cloneDeep(newVal);
        } else {
          this.localNotificationPreferences = [];
        }
      },
      immediate: true,
    },
  },
  created() {
    this.$store.dispatch('member/currentMemberNotificationPreferences');
  },
  methods: {
    handleElementSubscription(element) {
      const localNotifElement = cloneDeep(element);
      localNotifElement.isSubscribed = false;
      localNotifElement.notificationTypeSubscriptions.forEach((type) => {
        if (type.notificationTypeId === 2
        && element.notifiableElementIsMandatorySubscription) {
          // Emails are always subscribed if the element is mandatory
          // eslint-disable-next-line no-param-reassign
          type.isSubscribed = true;
        }
        localNotifElement.isSubscribed = localNotifElement.isSubscribed || type.isSubscribed;
      });
      for (let i = 0; i < this.localNotificationPreferences.length; i += 1) {
        if (this.localNotificationPreferences[i].notifiableElementId
            === localNotifElement.notifiableElementId) {
          this.localNotificationPreferences[i] = localNotifElement;
          return;
        }
      }
    },
    display(element) {
      return element.notifiableElementName === 'NOTIFIABLE_ELEMENT_TYPE.TIME_SHEET' || element.notifiableElementName === 'NOTIFIABLE_ELEMENT_TYPE.JOBS';
    },
    save() {
      this.$store
        .dispatch(
          'member/saveNotificationPreferences',
          this.localNotificationPreferences,
        )
        .then(() => {
          this.$store.commit('alerts/setAlert', {
            msg: 'PROFILE.NOTIFICATIONS.CONFIRMATION_MESSAGE',
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.profile-settings {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
</style>
